import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface IDriverDetail {
    id?: string
    prefix?: string
    shopId?: string
    shopCode?: string
    shopName?: string
    branch?: string
    ver?: string
    enable?: string
    orgCode?: string
    orgName?: string
    contact?: string
    phone?: string
    address?: string
    status?: number | boolean
    sourceApp?: string
    categoryName?: string
    typeCode?: string
    typeName?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    style?: string
    note?: string
    orderNum?: number
    traceId?: string
    deleteFlag?: number
    createTime?: string
    updateTime?: string
    createUser?: string
    updateUser?: string
    [key: string]: any
}
//新增
export interface IDriverInsert {
    prefix?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    note?: string
    style?: string
}

//编辑
export interface IDriverUpdate extends IDriverInsert {
    id?: string
}
//搜索条件
export interface IDriverSearchFields {
    startTime?: string
    endTime?: string
    [key: string]: any
}

export interface IDriverSearch extends IDriverSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IDriverSearchFields, ISearchPage {}

class Service {
    async page(searchVo: IDriverSearch, config: object = {}) {
        const apiUrl = '/threeInspection/base/driver/list'
        return await httpRequest.post<IPage<IDriverDetail>>(apiUrl, searchVo, config)
    }
    async insert(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/base/driver/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async edit(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/base/driver/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async onDelete(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/base/driver/delete'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async one(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/ciOrder/page'
        return await httpRequest.post<IPage<IDriverDetail>>(apiUrl, searchVo)
    }
    async orderLogs(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/ciOrder/progress_log/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async getDriverImg(updateVo: IDriverUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getImageClassifyList(updateVo: IDriverUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
}

export const service = new Service()
